var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.176,
    height: 34.338,
    viewBox: "0 0 37.176 34.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.04,
    y1: 2.516,
    x2: 0.259,
    y2: -0.717,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#405cfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab5fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.765,
    y1: 2.687,
    x2: 0.072,
    y2: -0.516,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-cart",
    "data-name": "Icon ionic-ios-cart",
    transform: "translate(-3.382 -4.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M13.854,30.271a2.146,2.146,0,1,1-2.146-2.146,2.146,2.146,0,0,1,2.146,2.146Z",
    transform: "translate(1.678 6.414)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M29.639,30.271a2.146,2.146,0,1,1-2.146-2.146,2.146,2.146,0,0,1,2.146,2.146Z",
    transform: "translate(5.962 6.414)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M40.544,10.6a.526.526,0,0,0-.465-.375L10.963,7.407a.9.9,0,0,1-.67-.42A9.1,9.1,0,0,0,9.2,5.324c-.688-.84-1.985-.814-4.363-.831a1.3,1.3,0,0,0-1.457,1.26,1.278,1.278,0,0,0,1.395,1.26,11.878,11.878,0,0,1,2.324.17c.42.125.76.814.885,1.412a.033.033,0,0,0,.009.027c.018.107.179.912.179.921L11.75,28.46a6.952,6.952,0,0,0,1.3,3.191A3.568,3.568,0,0,0,15.987,33.1H37.138a1.271,1.271,0,0,0,1.287-1.2A1.246,1.246,0,0,0,37.174,30.6h-21.2a1.039,1.039,0,0,1-.742-.25A4.012,4.012,0,0,1,14.2,28.022L13.815,25.9a.049.049,0,0,1,.036-.054l24.826-4.2a.522.522,0,0,0,.438-.465l1.43-10.352A.51.51,0,0,0,40.544,10.6Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBlue);
export default __webpack_public_path__ + "static/media/cart-blue.f26c4e2cc7a5e53bea5d6ff824256e68.svg";
export { ForwardRef as ReactComponent };